module.exports = __webpack_public_path__ + "img/konfigurasi_banner.cc45df8e.svg";